class UploadCandidateDocumentController {
    /*@ngInject*/
    constructor($scope, $rootScope, $timeout, alertsAndNotificationsService, userService, documentService, MESSAGECONSTANTS, documentActionService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.userService = userService;
        this.documentService = documentService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.documentActionService = documentActionService;
        Dropzone.autoDiscover = false; // disable dropdown instantiation done in the plugin
    }
    $onInit() {
        this.userId = this.$rootScope.userDetails.id;
        this.isEdit = this.document.id ? true : false;
        if (this.share === undefined) {
            this.share = false;
        }
        else {
            this.document.shared = true;
        }
        this.hideShare = (!this.share && !this.showUpload) || (this.showUpload && !this.isSharedDocumentActionAvailable);
        this.showUploadWizard = !this.isEdit;
        this.uploadClicked = false;
        this.initVariables();
        this.getCompaniesToShareCandidateDocuments();
        this.documentList = [];
        // wait for changes to take effect and then create wizard
        this.$timeout(() => {
            //initialize the drop zone configuration
            this.documentUploadDropzone = this.createDocumentUploadDropZone();
            // if(this.isEdit) {
            //     this._setFileInUploadDropZone(this.document.name, 10);
            // }
        }, 200);
        this.originalSharedEntityIds = this.document ? _.cloneDeep(this.document.sharedEntityIds) : "";
    }
    _setFileInUploadDropZone(fileName, fileSize) {
        let mockFile = {
            name: fileName,
            size: fileSize
        };
        this.documentUploadDropzone.options.addedfile.call(this.documentUploadDropzone, mockFile);
        // delete the DOM for 'remove button' option from the file in drop zone since job is now in 'open' status
        // find the remove button in the drop zone and delete it.
        $('.dz-remove').remove();
        // find the progress bar in the drop zone and delete it.
        $('.dz-progress').remove();
        // add the success tick mark onto the file
        $('.dz-file-preview.dz-preview').addClass('dz-success');
    }
    initVariables() {
        this.documentList = [];
        this.companiesToShare = [];
        this.selectedCompaniesToShare = [];
        this.uploadResumesResponse = null;
        // flags
        this.disableUploadButtonFlag = true;
        this.fileExistsFlag = false;
        this.fileUploadInProgressFlag = false;
    }
    getCompaniesToShareCandidateDocuments() {
        this.companiesToShare = this.companiesToShareCandidateDocuments ? [...this.companiesToShareCandidateDocuments] : [];
        this.companiesToShare.map(company => company.selected = false);
        if (this.companiesToShare) {
            this.companiesToShare.forEach(company => {
                if (this.document.sharedEntityIds.includes(company.id)) {
                    company.selected = true;
                    this.selectedCompaniesToShare.push(company);
                }
            });
        }
    }
    /**
     * creates the resume upload drop zone.
     */
    createDocumentUploadDropZone() {
        let dropZoneSettings = this._getDropZoneSettings();
        let documentUploadDropzone = new Dropzone("form#documentUploadDropzone", dropZoneSettings);
        // add event handlers for the drop zone
        documentUploadDropzone.on('addedfile', (file, response) => {
            this.fileExistsFlag = true;
            this.disableUploadButtonFlag = false;
            $('.dz-progress').css({ top: '70%' });
        });
        documentUploadDropzone.on('removedfile', (file, response) => {
            this.fileExistsFlag = false;
            this.disableUploadButtonFlag = true;
            this.fileUploadInProgressFlag = false;
        });
        documentUploadDropzone.on('sendingmultiple', (file, xhr, formData) => {
            // disable the upload button to avoid multiple clicks
            this.disableUploadButtonFlag = true;
            // indicate that file upload is in progress
            this.fileUploadInProgressFlag = true;
            let sharedEntityIds = this.document.shared ? this.document.sharedEntityIds.join(",") : null;
            if (this.document.id) {
                formData.append('documentId', this.document.id);
            }
            formData.append('companyId', this.document.companyId);
            formData.append('candidateId', this.document.candidateId);
            formData.append('internalNote', this.document.internalNote);
            formData.append('sharedEntityIds', sharedEntityIds);
            formData.append('shareDocument', this.document.shared);
            formData.append('folderId', this.document.folderId);
            formData.append('candidateType', this.candidateType);
            formData.append('userId', this.userId);
            if (this.candidateDetails.jobMatchId) {
                formData.append('jobMatchId', this.candidateDetails.jobMatchId);
            }
        });
        documentUploadDropzone.on('successmultiple', (fileArray, response) => {
            // remove file upload in progress flag
            this.fileUploadInProgressFlag = false;
            this.disableUploadButtonFlag = true;
            this.uploadResumesResponse = response;
            if (angular.isDefined(response.files) && response.files.length > 0) {
                this.documentList = [...response.files];
            }
            // disable adding of further files
            $(".dz-hidden-input").prop("disabled", true);
            this.alertsAndNotificationsService.showBannerMessage("Document(s) uploaded successfully.", "success");
            if (this.saveCallback) {
                this.saveCallback();
            }
        });
        documentUploadDropzone.on("error", (file, error) => {
            this.fileUploadInProgressFlag = false;
            let elements = document.querySelectorAll(".dz-file-preview");
            angular.forEach(elements, (element, index) => {
                let filename = element.querySelectorAll(".dz-filename span")[0].textContent;
                let errorMessage = element.querySelectorAll(".dz-error-message span")[0];
                if (filename === file.name) {
                    errorMessage.textContent = error.message == undefined ? error : error.message;
                }
            });
        });
        return documentUploadDropzone;
    }
    _getDropZoneSettings() {
        let dropZoneSettings = {};
        let maxFilesToUpload = 100;
        dropZoneSettings = {
            url: this.documentService.getUploadUrl(),
            paramName: () => {
                return "files";
            },
            acceptedFiles: ".pdf,.xlsx,.docx,.doc",
            maxFiles: maxFilesToUpload,
            maxFilesize: 10,
            maxThumbnailFilesize: 10,
            timeout: 300000,
            addRemoveLinks: true,
            autoProcessQueue: false,
            uploadMultiple: true,
            parallelUploads: 100
        };
        return dropZoneSettings;
    }
    onCompanyToShareSelected() {
        if (this.selectedCompaniesToShare && this.selectedCompaniesToShare.length > 0) {
            let sharedEntityIds = [];
            angular.forEach(this.selectedCompaniesToShare, (company, key) => {
                sharedEntityIds.push(company.id);
            });
            this.document.sharedEntityIds = sharedEntityIds.toString();
        }
    }
    updateDocumentData() {
        if (this._isDataValid()) {
            this.document.shareDocument = this.document.shared;
            this.document.documentId = this.document.id;
            if (this.originalSharedEntityIds && this.originalSharedEntityIds.length > 0) {
                let unSharedEntityIds = [];
                this.originalSharedEntityIds.map(company => {
                    if (!this.document.sharedEntityIds.includes(company)) {
                        unSharedEntityIds.push(company);
                    }
                });
                this.document.unSharedEntityIds = unSharedEntityIds.toString();
            }
            this.document.sharedEntityIds = this.document.shared ? this.document.sharedEntityIds.join(",") : null;
            this.document.candidateType = this.candidateType;
            this.document.userId = this.userId;
            this.documentActionService.setParentAndChildFolderName(this.allFolders, this.document);
            if (this.candidateDetails.jobMatchId) {
                this.document.jobMatchId = this.candidateDetails.jobMatchId;
            }
            this.documentService.updateCandidateDocumentData(this.document, (data) => {
                const message = this.share ? "Document shared successfully." : "Document updated successfully.";
                this.alertsAndNotificationsService.showBannerMessage(message, "success");
                if (this.saveCallback) {
                    this.saveCallback();
                }
            }, error => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, "danger");
            });
        }
    }
    uploadDocument() {
        this.uploadClicked = true;
        // if(!this.uploadDocumentForm.$invalid) {
        if (this._isDataValid()) {
            this.documentUploadDropzone.processQueue();
        }
        // }
    }
    _isDataValid() {
        this.document.sharedEntityIds = this.selectedCompaniesToShare.map(company => company.id);
        return !this.document.shared || (this.document.shared && this.document.sharedEntityIds.length >= 0);
    }
    removeAllSelectedCompanies() {
        this.companiesToShare.forEach(company => {
            company.selected = false;
        });
        this.selectedCompaniesToShare = [];
        this.document.sharedEntityIds = "";
    }
    receiveFormalizedComment(event) {
        this.document.internalNote = event;
    }
    onVoiceTranscript(transcript) {
        if (this.document.internalNote) {
            this.document.internalNote += ' ' + transcript;
        }
        else {
            this.document.internalNote = transcript;
        }
    }
}
UploadCandidateDocumentController.$inject = ['$scope', '$rootScope', '$timeout', 'alertsAndNotificationsService', 'userService', 'documentService', 'MESSAGECONSTANTS', 'documentActionService'];
// import * as TEMPLATE from './upload-candidate-document.html';
import * as TEMPLATE from 'raw-loader!./upload-candidate-document.html';
export const UploadCandidateDocumentComponent = {
    selector: 'uploadCandidateDocument',
    component: {
        bindings: {
            document: '<',
            showUpload: '<',
            share: '<',
            candidateType: '<',
            candidateDetails: '<',
            cancelCallback: '&',
            saveCallback: '&',
            controlObject: '=',
            allFolders: '<',
            isSharedDocumentActionAvailable: '<',
            companiesToShareCandidateDocuments: '<',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: UploadCandidateDocumentController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateprofile/candidateProfile/candidateDocuments/uploadCandidateDocument/upload-candidate-document.html'
    }
};
//# sourceMappingURL=upload-candidate-document.component.js.map